import { Button } from "antd";
import React from "react";

export const ButtonActiveModal = ({
	icon = "",
	action = () => {
		console.log("modal");
	},
	shape = "default",
	size = {
		h: "40px",
		w: "40px",
	},
	className = "",
	title = "",
}) => {
	return (
		<Button className={className} type="primary" icon={icon} onClick={action} shape={shape} style={{ width: size.w, height: size.h }}>
			{title}
		</Button>
	);
};
